import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  text: {
    thank_you: 'Thank you, {{name}}',
    confirmation_email:
      'You’ll get a confirmation email with your order number soon to your E-Mail by our Tech-Partner {{provider_email}}',
    need_help: 'Need help?',
  },
  labels: {
    order_number: 'Nr. {{number}} - {{method}}',
    restaurant: 'Restaurant',
    order_details: 'Order details',
    contact: 'Contact',
    payment_method: 'Payment method',
    delivery: 'Delivery',
    billing_info: 'Billing information',
    order_summary: 'Order summary',
  },
  order_methods: {
    [ORDER_METHODS.PICKUP]: 'Pickup order',
    [ORDER_METHODS.DELIVERY]: 'Delivery order',
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Room service',
      [RoomServiceLocationType.TableService]: 'Table order',
    },
  },
  room_service_details: {
    [RoomServiceLocationType.RoomService]: '(room #{{details}})',
    [RoomServiceLocationType.TableService]: '(table #{{details}})',
  },
  buttons: {
    back_to_menu: 'Back to Menu',
    back_to_checkout: 'Back to checkout',
    contact_us: 'Contact us {{phone_number}}',
  },
  loading: {
    processing_payment: 'Please do not leave the page while we process your payment',
  },
  error_messages: {
    failed_to_load: 'Order could not be loaded. Please try again.',
    payment_failed: 'Payment failed, please try again',
  },
};
